import * as d3 from "d3";
import $ from 'jquery';
import { addCommas, addPlus, genderTooltip, downloadData } from './helpers';
import * as axios from 'axios';
const moment = require('moment');

const margin = { top: 20, right: 20, bottom: 130, left: 50 },
    width = 960 - margin.left - margin.right,
    height = 475 - margin.top - margin.bottom;

var svg = d3.select('#mh-chart').append('svg')
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)

var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

var parseTime = d3.timeParse('%Y-%m-%d')

const pageWidth = window.innerWidth

const bisectDate = d3.bisector(function (d) {
    return d.date;
}).left;

var formatTime = d3.timeFormat("%m/%d/%Y");

var x = d3.scaleTime().range([0, width], 0.5);
var y = d3.scaleLinear().range([height, 0]);
var color = d3.scaleOrdinal(["#4D4E56", "#EF4136", "#BCBDBC"]);

var xAxis = d3.axisBottom(x).tickFormat(d3.timeFormat("%b %Y"))

var yAxis = d3.axisLeft(y).ticks(5);


var line = d3.line()
    .x(d => x(d.date))
    .y(d => y(d.value))

const caseData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
    .then(facilities => {

        const mhData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=145516429&single=true&output=csv")
            .then(content => {

                const justData = content.data
                const csv = d3.csvParse(justData)

                console.log('csv', csv)
                // case data totals to get %s of MH population
                const caseData = d3.csvParse(facilities.data)

                caseData.forEach(function (d) {
                    d.formattedDate = parseTime(d.date);
                });
                caseData.sort((a, b) => b.formattedDate - a.formattedDate)

                const mostRecentDayCase = caseData[0].date
                const formatCurrentDay = parseTime(mostRecentDayCase)
                const formatBackCurrentDay = formatTime(formatCurrentDay)

                d3.select('#current-date-home').append('text').text(formatBackCurrentDay)

                // topline numbers
                const csvClone = JSON.parse(JSON.stringify(csv));

                csvClone.forEach(function (d) {
                    d.formattedDate = parseTime(d.date);
                });
                csvClone.sort((a, b) => b.formattedDate - a.formattedDate)
                const mostRecentDay = csvClone[0].date
                const formatMostRecentDay = parseTime(mostRecentDay)
                const reformatDay = formatTime(formatMostRecentDay)

                d3.select('.mh-current-date').append('text').text(reformatDay)

                const mostRecentMHData = csvClone.filter(d => d.date == mostRecentDay)

                const totalMH = d3.nest()
                    .key(d => d.date)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(mostRecentMHData)

                const MHbySex = d3.nest()
                    .key(d => d.date)
                    .key(d => d.sex)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(mostRecentMHData)

                const MHMales = MHbySex[0].values[0].value
                const MHFemales = MHbySex[0].values[1].value

                const currentMHCases = totalMH[0].value

                d3.selectAll('.pop-num-mh').append('text').text(addCommas(currentMHCases))

                const totalMHGroup = d3.nest()
                    .key(d => d.date)
                    .key(d => d.level)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(mostRecentMHData)

                d3.selectAll('.pop-num-gpm').append('text').text(addCommas(totalMHGroup[0].values[2].value))
                d3.selectAll('.pop-num-hoh').append('text').text(addCommas(totalMHGroup[0].values[0].value))
                d3.selectAll('.pop-num-moh').append('text').text(addCommas(totalMHGroup[0].values[1].value))

                const caseDataMHDate = caseData.filter(d => d.date == mostRecentDay)

                const totalCase = d3.nest()
                    .key(d => d.date)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(caseDataMHDate)

                const casesbySex = d3.nest()
                    .key(d => d.date)
                    .key(d => d.sex)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(caseDataMHDate)

                const currentTotalCases = totalCase[0].value
                const currentCasesMales = casesbySex[0].values[0].value
                const currentCasesFemales = casesbySex[0].values[1].value

                const percMH = (currentMHCases / currentTotalCases) * 100
                d3.select('.perc-mh-total').append('text').text(percMH.toFixed(0) + '%')

                const percMHMales = (MHMales / currentCasesMales) * 100
                d3.select('.perc-mh-males').append('text').text(percMHMales.toFixed(0) + '%')

                const percMHFemales = (MHFemales / currentCasesFemales) * 100
                d3.select('.perc-mh-females').append('text').text(percMHFemales.toFixed(0) + '%')

                //////////////////// change since...
                var formatDate = d3.timeFormat("%Y-%m-%d");
                var formatTimeforMoment = d3.timeFormat("%Y-%m-%d");

                let momentCurrentDay = moment(mostRecentDay)

                let aWeekAgo = momentCurrentDay.clone().subtract(1, 'week')
                let aMonthAgo = momentCurrentDay.clone().subtract(1, 'month')
                let aYearAgo = momentCurrentDay.clone().subtract(1, 'year')

                ////// find the date closest to a year ago

                const datesToBeChecked = csvClone.map(a => a.date);
                const dateToCheckFor = aYearAgo

                let nearestDateYear;

                datesToBeChecked.forEach(date => {
                    let diff = moment(date).diff(moment(dateToCheckFor), 'days');
                    if (diff > 0) {
                        if (nearestDateYear) {
                            if (moment(date).diff(moment(nearestDateYear), 'days') < 0) {
                                nearestDateYear = date;
                            }
                        } else {
                            nearestDateYear = date;
                        }
                    }
                });

                // a month ago
                const dateToCheckForMonth = aMonthAgo

                let nearestDateMonth;

                datesToBeChecked.forEach(date => {
                    let diff = moment(date).diff(moment(dateToCheckForMonth), 'days');
                    if (diff > 0) {
                        if (nearestDateMonth) {
                            if (moment(date).diff(moment(nearestDateMonth), 'days') < 0) {
                                nearestDateMonth = date;
                            }
                        } else {
                            nearestDateMonth = date;
                        }
                    }
                });

                // a week ago
                const dateToCheckForWeek = aWeekAgo

                let nearestDateWeek;

                datesToBeChecked.forEach(date => {
                    let diff = moment(date).diff(moment(dateToCheckForWeek), 'days');
                    if (diff > 0) {
                        if (nearestDateMonth) {
                            if (moment(date).diff(moment(nearestDateWeek), 'days') < 0) {
                                nearestDateWeek = date;
                            }
                        } else {
                            nearestDateWeek = date;
                        }
                    }
                });

                ////////////////////////////////////////

                // const lastWeek = csvClone.filter(function (d) { return d.date == formatDate(aWeekAgo._d) })
                const lastWeek = csvClone.filter(function (d) { return d.date == nearestDateWeek })
                const lastMonth = csvClone.filter(function (d) { return d.date == nearestDateMonth })
                const lastYear = csvClone.filter(function (d) { return d.date == nearestDateYear })

                const changeLastWeek = d3.nest()
                    .key(d => d.level)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(lastWeek);

                const changeLastMonth = d3.nest()
                    .key(d => d.level)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(lastMonth);

                const changeLastYear = d3.nest()
                    .key(d => d.level)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(lastYear);

                // initial - weekly change
                let totalMHPopChange, mhPopGPMChange, mhPopHOHChange, mhPopMOHChange
                if (changeLastWeek.length == 0) {
                    totalMHPopChange = 0,
                        mhPopGPMChange = 0,
                        mhPopHOHChange = 0,
                        mhPopMOHChange = 0
                } else {
                    totalMHPopChange = addCommas(addPlus(currentMHCases - (changeLastWeek[0].value + changeLastWeek[1].value + changeLastWeek[2].value))),
                        mhPopGPMChange = addCommas(addPlus(totalMHGroup[0].values[2].value - changeLastWeek[2].value)),
                        mhPopHOHChange = addCommas(addPlus(totalMHGroup[0].values[0].value - changeLastWeek[0].value)),
                        mhPopMOHChange = addCommas(addPlus(totalMHGroup[0].values[1].value - changeLastWeek[1].value))
                }

                $(".pop-num-mh-change").text(totalMHPopChange)
                $(".pop-num-gpm-change").text(mhPopGPMChange)
                $(".pop-num-hoh-change").text(mhPopHOHChange)
                $(".pop-num-moh-change").text(mhPopMOHChange)

                const mhChangeSelect = d3.select("#mhchangedate")
                    .on("change", function () {
                        let changeDate = this.value
                        updateMHChange(changeDate)
                    })
                function updateMHChange(changeDate) {
                    let changeData
                    if (changeDate == 'Week') { changeData = changeLastWeek }
                    else if (changeDate == 'Month') { changeData = changeLastMonth }
                    else if (changeDate == 'Year') { changeData = changeLastYear }

                    let totalMHPopChange = addCommas(addPlus(currentMHCases - (changeData[0].value + changeData[1].value + changeData[2].value))),
                        mhPopGPMChange = addCommas(addPlus(totalMHGroup[0].values[2].value - changeData[2].value)),
                        mhPopHOHChange = addCommas(addPlus(totalMHGroup[0].values[0].value - changeData[0].value)),
                        mhPopMOHChange = addCommas(addPlus(totalMHGroup[0].values[1].value - changeData[1].value))
                    $(".pop-num-mh-change").text(totalMHPopChange)
                    $(".pop-num-gpm-change").text(mhPopGPMChange)
                    $(".pop-num-hoh-change").text(mhPopHOHChange)
                    $(".pop-num-moh-change").text(mhPopMOHChange)

                    // let totalPopNumMaleChangePerc, totalPopNumFemaleChangePerc, totalPopNumChangePerc
                    // if (totalPopNumMaleChange > 0) {
                    //     totalPopNumMaleChangePerc = '+' + ((changeData[0].value / genderdata[0].value) * 100).toFixed(1) + '%'
                    // } else {
                    //     totalPopNumMaleChangePerc = ((1 - (changeData[0].value / genderdata[0].value)) * 100).toFixed(1) + '%'
                    // }
                    // if (totalPopNumFemaleChange > 0) {
                    //     totalPopNumFemaleChangePerc = '+' + ((changeData[1].value / genderdata[1].value) * 100).toFixed(1) + '%'
                    // } else {
                    //     totalPopNumFemaleChangePerc = ((1 - (changeData[1].value / genderdata[1].value)) * 100).toFixed(1) + '%'
                    // }
                    // if (totalPopNumChange > 0) {
                    //     totalPopNumChangePerc = '+' + (((changeData[0].value + changeData[1].value) / (genderdata[0].value + genderdata[1].value)) * 100).toFixed(1) + '%'
                    // } else {
                    //     totalPopNumChangePerc = ((1 - (changeData[0].value + changeData[1].value) / (genderdata[0].value + genderdata[1].value)) * 100).toFixed(1) + '%'
                    // }
                    // $(".total-pop-num-male-change-perc").text(totalPopNumMaleChangePerc)
                    // $(".total-pop-num-female-change-perc").text(totalPopNumFemaleChangePerc)
                    // $(".total-pop-num-change-perc").text(totalPopNumChangePerc)

                }

                ///////////////////

                // chart
                let data = csv
                // let data = csv.filter(d => d.sex == 'Females')
                updateGraph(data)

                d3.selectAll(".genderbuttone").on("click", function () {
                    var section = d3.select(this).attr("id");
                    if (d3.select(this).classed("selected")) {
                    } else {
                        d3.selectAll(".genderbuttone").classed("selected", false);
                        d3.select(this).classed("selected", true);
                    }
                    if (section == 'All') { data = csv } else {
                        data = csv.filter(d => d.sex == section)
                    }

                    updateGraph(data);
                })
                data = csv
                updateGraph(data);
            })
    })
function updateGraph(selectedData) {

    const newdata = d3.nest()
        .key(d => d.date)
        .key(d => d.level)
        .rollup(v => d3.sum(v, d => d.value))
        .entries(selectedData);

    const flattenData = newdata.flatMap((item, i) => {
        const date = item.key;
        return item.values.map(level => ({
            date: date,
            level: level.key,
            value: level.value
        }));
    });

    const data = d3.nest()
        .key(d => d["date"])
        .rollup(function (d) {
            return d.reduce(function (prev, curr) {
                prev["date"] = curr["date"];
                // prev["sex"] = curr["sex"];
                prev[curr["level"]] = curr["value"];
                return prev;
            }, {});
        })
        .entries(flattenData)
        .map(d => d.value)

    color.domain(d3.keys(data[0]).filter(function (key) {
        return key !== "date" && key !== "sex" && key !== "_id";
    }));

    data.forEach(function (d) {
        d.date = parseTime(d.date);
    });
    data.sort((a, b) => a.date - b.date)

    var levels = color.domain().map(function (name) {
        return {
            name: name,
            values: data.map(function (d) {
                return {
                    date: d.date,
                    value: +d[name]
                };
            })
        };
    });

    x.domain(d3.extent(data, d => d.date))
    y.domain([
        d3.min(levels, function (c) {
            return d3.min(c.values, function (v) {
                return v.value;
            });
        }),
        d3.max(levels, function (c) {
            return d3.max(c.values, function (v) {
                return v.value + 20;
            });
        })
    ]);

    var lines = g.selectAll(".line")
        .data(levels)

    lines.enter().append("path")
        .attr("class", "line");

    lines.transition().duration(750)
        .style("stroke", d => color(d.name))
        .style('stroke-width', 2.5)
        .attr("id", d => d.level)
        .attr("d", d => line(d.values))

    lines.exit().remove();

    // var labs = g.selectAll('.label')
    //     .data(levels)

    // labs.enter().append('text')
    //     .attr('class', 'label')

    // labs.transition().duration(0)
    //     .attr('fill', '#000')
    //     .attr("x", width)
    //     .attr("y", d => y(d.values[d.values.length - 1].value) - 2)
    //     .text(d => {
    //         if (d.name == "GPm") { return "General Population receiving meds" }
    //         else if (d.name == "HOH") { return "High Observation Housing" }
    //         else if (d.name == "MOH") { return "Moderate Observation Housing" }
    //     });

    // labs.exit().remove()

    svg.selectAll(".axis").remove();

    g.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis);

    g.append("g")
        .attr("class", "y axis")
        .call(yAxis.ticks(5))
        .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".71em")
        .style("text-anchor", "end")
        .text("Value (USD)");

    var legend = g.selectAll(".legend")
        .data(levels);

    legend.enter().append("rect")
        .attr("width", 10)
        .attr("height", 10)
        .attr("x", 0)
        .attr("y", function (d, i) { return (height + 40) + i * 20; })
        .attr("fill", function (d) {
            return color(d.name);
        })

    legend.enter().append("text")
        .attr("x", 15)
        .attr("y", function (d, i) { return (height + 50) + i * 20; })
        .attr('font-family', 'GT Walsheim Regular')
        .attr('font-size', 16)
        .attr("class", "legend");

    legend.transition()
        .style("fill", "#777")
        .text(d => {
            if (d.name == "GPm") { return "Población general que recibe medicamentos" }
            else if (d.name == "HOH") { return "Dormitorio de alta observación" }
            else if (d.name == "MOH") { return "Dormitorio de observación moderada" }
        });

    legend.exit().remove();

    // tooltips
    const overlay = g.append('rect'),
        focus = g.append('g').attr("class", "focus")

    var mainTooltip = d3.select("body").append("div")
        .attr("class", "mainTooltip");

    focus
        .style("display", "none");

    focus.append("rect")
        .attr('x', -.5)
        .attr('y', 0)
        .attr('width', 1)
        .attr('height', height + 11)
        .attr('fill', '#666')

    overlay
        .attr("class", "overlay")
        .attr("width", width)
        .attr("height", height)
        .on("mouseover", function () {
            focus.style("display", null);
        })
        .on("mouseout", function () {
            focus.style("display", "none");
            mainTooltip.style("visibility", "hidden");
        })
        .on("mousemove", mousemove);

    function mousemove() {
        var main_hover = d3.select('.main-hover')
        main_hover.attr("y", event.pageY - 140 + "px").attr('x', 0)

        var x0 = x.invert(d3.mouse(this)[0]),
            i = bisectDate(data, x0, 1),
            d0 = data[i - 1],
            d1 = data[i],
            d = x0 - d0.date > d1.date - x0 ? d1 : d0;

        var formatTime = d3.timeFormat("%m/%d/%Y");

        focus.attr("transform", "translate(" + x(d.date) + "," + 0 + ")");

        let tooltip_str = formatTime(d.date) + "<br/>" +
            "<div class='tooltip-label' style='background:#EF4136;'></div>Dormitorio de observación moderada: " + addCommas(d.MOH) + "<br/>" +
            "<div class='tooltip-label' style='background:#BCBDBC;color:#000;'></div>Población general que recibe medicamentos: " + addCommas(d.GPm) + "<br/>" +
            "<div class='tooltip-label' style='background:#4D4E56;'></div>Dormitorio de alta observación: " + addCommas(d.HOH)

        mainTooltip
            .style('left', (pageWidth - (width + margin.right + margin.left)) / 2 + (margin.left / 2) + 5 + x(d.date) + 'px')
            .style("top", event.pageY - 140 + "px").attr('x', 0)
            .html(tooltip_str)
            .style("visibility", "visible")

    }

    // Define responsive behavior
    function resize() {
        var width =
            parseInt(d3.select("#mh-chart").style("width")) - margin.left - margin.right,
            height =
                parseInt(d3.select("#mh-chart").style("height")) -
                margin.top -
                margin.bottom;

        x.range([0, width]);
        y.range([height, 0]);

        svg
            .select(".x.axis")
            .attr("transform", "translate(0," + height + ")")
            .call(xAxis);

        svg.select(".y.axis").call(yAxis);

        svg.selectAll(".line").attr("d", d => line(d.values));

        svg.selectAll('.label')
            .attr('x', width)
            .attr("y", d => y(d.values[d.values.length - 1].value) - 2)

        xAxis.ticks(Math.max(width / 100, 2));
        yAxis.ticks(Math.max(height / 50, 2));
    }

    d3.select(window).on("resize", resize);

    resize();
};